


















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import ProductApi from '@/api/marketing/rewardPointMall/product/index'
@Component
export default class RewardPointProductSelect extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return []
    }
  })
  selectedItems!: string[]

  @Prop({
    type: Boolean,
    default: true
  })
  IsMultiple!: boolean

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1

  data = []
  get columns() {
    var data: any[] = [
      {
        title: '商品名称',
        width: 350,
        key: 'productName'
      },
      {
        title: '货号',
        key: 'productCode'
      },
      {
        title: '售价',
        key: 'price'
      },
      {
        title: '库存',
        key: 'stockQuantity'
      },
      {
        title: '状态',
        key: 'published',
        slot: 'published'
      }
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center'
      })
    }
    return data
  }
  async mounted() {}
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.loadGoodsList()
  }

  async loadGoodsList() {
    ProductApi.getRewardPointProduct
    await ProductApi.getList(this.pageSize, this.pageIndex).then(res => {
      this.total = res.data.totalCount
      let result = []
      res.data.items.forEach(element => {
        element['_disabled'] =
          this.selectedItems.findIndex(x => x == element.id) > -1
        result.push(element)
      })
      this.data = result
    })
  }
  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.loadGoodsList()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow.id)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection())
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.modal1 = false
  }
}
